module.exports = __webpack_public_path__ + "static/media/book5.a9cb8e16.jpg";